/**
 * 코퍼레이트 정보 페이지 공통 클린 배너 (이미지 배너 대체).
 * bg-soft 배경 + 우상단 rotate(45deg) 다이아 데코. eyebrow → h1 → 한 줄 설명(→ 메타 칩).
 */
interface CleanBannerProps {
  eyebrow: string;
  title: string;
  desc: string;
  meta?: string[];
}

export default function CleanBanner({ eyebrow, title, desc, meta }: CleanBannerProps) {
  return (
    <section className="cp-banner">
      <span className="cp-banner__deco cp-banner__deco--red" aria-hidden />
      <span className="cp-banner__deco cp-banner__deco--grey" aria-hidden />
      <div className="cp-banner__inner">
        <div className="cp-banner__eyebrow">{eyebrow}</div>
        <h1 className="cp-banner__title">{title}</h1>
        <p className="cp-banner__sub">{desc}</p>
        {meta && meta.length > 0 && (
          <div className="cp-banner__meta">
            {meta.map((m) => (
              <span key={m} className="cp-banner__chip">
                {m}
              </span>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
